import React, { useState, useEffect } from "react";
import classes from "../module.css/ManageForm.module.css";
import { AiFillPlusCircle } from "react-icons/ai";
import Badge from "../tailwindUI/Badge";
import Input from "../tailwindUI/Input";
import ErrorMessage from "../tailwindUI/ErrorMessage";

function ManageForm(props) {
  const [modelName, setModelName] = useState("");
  const [fuelType, setFuelType] = useState("");
  const [colorName, setColorName] = useState("");
  const [colorGroup, setColorGroup] = useState([]);
  const [imgLink, setImgLink] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [newVariant, setNewVariant] = useState({
    frontendVariant: "",
    gdmsVariant: "",
    specCode: "",
  });
  const [variantGroup, setVariantGroup] = useState([]);
  const [errors, setErrors] = useState({});
  const [variantErrors, setVariantErrors] = useState({
    frontendVariant: "",
    gdmsVariant: "",
    specCode: "",
  });

  useEffect(() => {
    if (props.updateData !== "") {
      console.log(props.updateData, "Update Data");

      setModelName(props.updateData.model);
      setFuelType(props.updateData.fuel_type);
      const updateVariantGroup = props.updateData.CarVarient.map((v) => ({
        frontendVariant: v.FrontendVarient,
        gdmsVariant: v.GDMSVarient,
        specCode: v.SpecificationCode,
      }));
      setVariantGroup(updateVariantGroup);
      setImgLink(props.updateData.carmodel_image);
      const updateColorGroup = props.updateData.colour.split(",");
      setColorGroup(updateColorGroup);
    } else {
      resetForm();
    }
  }, [props.updateData]);

  const validateForm = () => {
    const newErrors = {};
    if (!modelName.trim()) newErrors.modelName = "Model name is required.";
    if (!fuelType.trim()) newErrors.fuelType = "Fuel type is required.";
    if (!colorGroup.length)
      newErrors.colorGroup = "At least one color is required.";
    if (!variantGroup.length)
      newErrors.variantGroup = "At least one variant is required.";
    if (!imgLink || imgLink.length === 0)
      newErrors.imgLink = "Please Upload model image.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleVariantInputChange = (field, value) => {
    setNewVariant((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const imageHandler = () => {
    document.getElementById("modelImg").click();
  };

  const addVariant = () => {
    const errors = {};
    if (!newVariant.frontendVariant.trim())
      errors.frontendVariant = "Frontend Variant is required.";
    if (!newVariant.gdmsVariant.trim())
      errors.gdmsVariant = "GDMS Variant is required.";
    if (!newVariant.specCode.trim())
      errors.specCode = "Specification Code is required.";

    if (Object.keys(errors).length > 0) {
      setVariantErrors(errors);
      return;
    }

    setVariantGroup([...variantGroup, newVariant]);
    setNewVariant({ frontendVariant: "", gdmsVariant: "", specCode: "" });
    setVariantErrors({});
  };

  const removeVariant = (index) => {
    const updatedVariants = variantGroup.filter((_, i) => i !== index);
    setVariantGroup(updatedVariants);
  };

  const removeVariantApi = async (SpecificationCode, CardbID) => {
    let fetchedData = await fetch(
      `${global.apiBaseUrl}/api/v1/stockone/edp/EDPCarVarientDelete`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: global.authToken,
        },
        body: JSON.stringify({
          FrontendVarient: SpecificationCode,
          UserToken: localStorage.getItem("UserToken"),
          model: modelName,
          fuel: fuelType,
        }),
      }
    );

    let parseData = await fetchedData.json();

    if (
      parseData.status_code === 200 &&
      parseData.message === "Car varient deleted successfully"
    ) {
      props.getSoloModel(CardbID);
    } else if (
      parseData.status_code === 200 &&
      parseData.message === "Car with varient exist in car stock"
    ) {
      setErrorMessage("Car Stock For This Variant Already Exists");
    }
  };

  const handleRemoveVariant = (index, variant) => {
    setErrorMessage("");
    props.actionName === "Save"
      ? removeVariant(index)
      : removeVariantApi(
          variant.frontendVariant.trim(),
          props.updateData.CardbID
        );
  };

  const addColor = () => {
    if (colorName.trim() && !colorGroup.includes(colorName)) {
      setColorGroup([...colorGroup, colorName]);
      setColorName("");
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        colorName: "Color name is required or already exists.",
      }));
    }
  };

  const removeColor = (color) => {
    const updatedColors = colorGroup.filter((c) => c !== color);
    setColorGroup(updatedColors);
  };

  const resetForm = () => {
    setModelName("");
    setFuelType("");
    setColorGroup([]);
    setVariantGroup([]);
    setNewVariant({ frontendVariant: "", gdmsVariant: "", specCode: "" });
    setErrors({});
    setImgLink("");
  };

  const callAction = () => {
    if (!validateForm()) return;

    const payload = variantGroup.map((variant) => ({
      CarModelName: modelName,
      CarVariant: variant.frontendVariant.trim(),
      GDMSCarVariant: variant.gdmsVariant.trim(),
      SpecificationCode: variant.specCode.trim(),
    }));

    console.log(payload, "Payload");
    if (props.action === 0) {
      const frontendVariants = variantGroup
        .map((variant) => variant.frontendVariant)
        .join(",");
      props.addModel(
        modelName,
        colorGroup,
        frontendVariants,
        fuelType,
        imgLink
      );
      props.addGDMSModel(payload);
      resetForm();
    } else if (props.action === 1) {
      const frontendVariants = variantGroup
        .map((variant) => variant.frontendVariant)
        .join(",");
      props.updateModel(
        modelName,
        colorGroup,
        frontendVariants,
        fuelType,
        imgLink,
        props.updateData.CardbID
      );
      props.addGDMSModel(payload);
    }
  };

  const notificationMethods = [
    { id: "petrol", title: "Petrol" },
    { id: "diesel", title: "Diesel" },
    { id: "cng", title: "CNG" },
    { id: "electric", title: "Electric" },
  ];

  // Function to handle specCode updates for a specific variant
  const handleSpecCodeChange = (index, value) => {
    const updatedVariants = [...variantGroup];
    updatedVariants[index].specCode = value;
    setVariantGroup(updatedVariants);
  };

  return (
    <>
      <div className="fixed z-20">
        {errorMessage && <ErrorMessage message={errorMessage} />}
      </div>
      <div className="my-2">
        <h1 className={classes.formHeading}>{props.formHeading}</h1>
      </div>
      <div className={classes.mainForm}>
        <form>
          <div className="flex">
            <div className={classes.strips}>
              <label htmlFor="modelName">Model Name</label>
              <input
                type="text"
                id="modelName"
                className={classes.simpleIb}
                style={{ width: "360px" }}
                value={modelName}
                onChange={(e) => setModelName(e.target.value)}
              />
              {errors.modelName && (
                <span className="error">{errors.modelName}</span>
              )}
            </div>
            <div className={classes.strips}>
              <label htmlFor="modelColor">Color</label>
              <div className="flex items-center gap-2">
                <input
                  type="text"
                  id="modelColor"
                  className={classes.simpleIb}
                  style={{ width: "360px" }}
                  value={colorName}
                  onChange={(e) => setColorName(e.target.value)}
                />
                <AiFillPlusCircle className="w-8 h-8" onClick={addColor} />
              </div>
              {errors.colorName && (
                <span className="error">{errors.colorName}</span>
              )}
            </div>
            <div className={`${classes.strips} ml-16`}>
              <h2 className="font-bold text-lg">Colors</h2>
              <div className={classes.colorInner}>
                {colorGroup.map((color, index) => (
                  <Badge
                    key={index}
                    text={color}
                    onClick={() => removeColor(color)}
                  />
                ))}
              </div>
              {errors.colorGroup && (
                <span className="error">{errors.colorGroup}</span>
              )}
            </div>
          </div>

          <div className="mt-4">
            <h2 className="font-bold text-lg mb-4">Variants</h2>
            <div className="flex items-center gap-4 mb-4">
              <div className="flex flex-col">
                <input
                  type="text"
                  placeholder="Frontend Variant"
                  className={`border ${
                    variantErrors.frontendVariant
                      ? "border-red-500"
                      : "border-gray-300"
                  } rounded px-2 py-1`}
                  value={newVariant.frontendVariant}
                  onChange={(e) =>
                    handleVariantInputChange("frontendVariant", e.target.value)
                  }
                />
                <div className="h-4">
                  {variantErrors.frontendVariant && (
                    <span className="text-red-500 text-sm">
                      {variantErrors.frontendVariant}
                    </span>
                  )}
                </div>
              </div>

              <div className="flex flex-col">
                <input
                  type="text"
                  placeholder="GDMS Variant"
                  className={`border ${
                    variantErrors.gdmsVariant
                      ? "border-red-500"
                      : "border-gray-300"
                  } rounded px-2 py-1`}
                  value={newVariant.gdmsVariant}
                  onChange={(e) =>
                    handleVariantInputChange("gdmsVariant", e.target.value)
                  }
                />
                <div className="h-4">
                  {variantErrors.gdmsVariant && (
                    <span className="text-red-500 text-sm">
                      {variantErrors.gdmsVariant}
                    </span>
                  )}
                </div>
              </div>

              <div className="flex flex-col">
                <input
                  type="text"
                  placeholder="Specification Code"
                  className={`border ${
                    variantErrors.specCode
                      ? "border-red-500"
                      : "border-gray-300"
                  } rounded px-2 py-1`}
                  value={newVariant.specCode}
                  onChange={(e) =>
                    handleVariantInputChange("specCode", e.target.value)
                  }
                />
                <div className="h-4">
                  {variantErrors.specCode && (
                    <span className="text-red-500 text-sm">
                      {variantErrors.specCode}
                    </span>
                  )}
                </div>
              </div>

              <AiFillPlusCircle
                className="w-8 h-8 cursor-pointer items-center -mt-4"
                onClick={addVariant}
              />
            </div>

            {variantGroup.length > 0 && (
              <>
                <table className="table-auto border-collapse border border-gray-300 w-full mt-4">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-4 py-2">
                        FE Variant
                      </th>
                      <th className="border border-gray-300 px-4 py-2">
                        GDMS Variant
                      </th>
                      <th className="border border-gray-300 px-4 py-2">
                        Spec Code
                      </th>
                      <th className="border border-gray-300 px-4 py-2">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {variantGroup.map((variant, index) => (
                      <tr key={index}>
                        <td className="border border-gray-300 px-4 py-2">
                          {variant.frontendVariant}
                        </td>
                        <td className="border border-gray-300 px-4 py-2">
                          {variant.gdmsVariant}
                        </td>
                        <td className="border border-gray-300 px-4 py-2">
                          <input
                            className="border border-black px-2 py-1 rounded-md focus:border-violet-600 w-full"
                            type="text"
                            value={variant.specCode}
                            onChange={(e) =>
                              handleSpecCodeChange(index, e.target.value)
                            }
                          />
                        </td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          <button
                            type="button"
                            className="text-red-500 border rounded-md border-red-500 px-2 py-1"
                            onClick={() => handleRemoveVariant(index, variant)}
                          >
                            Remove
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}
            {errors.variantGroup && (
              <span className="error">{errors.variantGroup}</span>
            )}
          </div>

          <div className={classes.strips}>
            <Input
              type="radio group"
              label="Fuel Type"
              onChange={() => setErrors((prev) => ({ ...prev, fuelType: "" }))}
              value={fuelType}
              setState={setFuelType}
              data={notificationMethods}
              error={errors.fuelType}
            />
            {errors.fuelType && (
              <span className="error">{errors.fuelType}</span>
            )}
          </div>

          <div className={classes.imgStrip}>
            <div className={classes.imgstt}>
              <label htmlFor="modelImg">Upload Car Image</label>
              <span className={classes.addBtn}>
                <AiFillPlusCircle onClick={imageHandler} />
              </span>
            </div>
            <div className={classes.ibImgArea}>
              {imgLink?.name ? (
                <p className="mt-2 text-sm">
                  <span className="text-Indigo-100">{imgLink?.name}</span>
                </p>
              ) : (
                <></>
              )}

              <a
                href={`${typeof imgLink === "string" ? imgLink : ""}`}
                target="_blank"
                className="text-Indigo-100 mt-2"
              >
                {`${typeof imgLink === "string" ? imgLink : ""}`}
              </a>

              <input
                type="file"
                id="modelImg"
                className={classes.imgIb}
                accept="image/*"
                onChange={(e) => {
                  setImgLink(e.target.files[0]);
                  if (e.target.files.length > 0) {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      imgLink: "",
                    }));
                  }
                }}
              />
            </div>
            {errors.imgLink && <span className="error">{errors.imgLink}</span>}
          </div>

          <div className="flex justify-end">
            <div className={classes.btnArea}>
              <button
                type="button"
                className="inline-flex items-center rounded-md border border-gray-300 bg-white px-6 py-2 text-sm font-medium leading-4 text-gray-700 shadow-sm hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-100 focus:ring-offset-2"
                onClick={resetForm}
              >
                Reset
              </button>
              <button
                type="button"
                className="inline-flex items-center rounded-md border border-transparent bg-indigo-700 px-6 py-2 text-sm font-medium leading-4 text-white shadow-sm hover:bg-indigo-900 focus:outline-none focus:ring-2 focus:ring-indigo-800 focus:ring-offset-1 ml-4"
                onClick={callAction}
              >
                {props.actionName}
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default ManageForm;
